import { HttpErrorResponse } from "@angular/common/http";
import { ErrorHandler, Injectable, Injector } from "@angular/core";
import { ErrorService } from "@services/error.service";
import { captureException, captureMessage, showReportDialog } from '@sentry/browser'
import { SelectSnapshot } from "@ngxs-labs/select-snapshot";
import { ConfigState } from "@store/config.state";
import { ILanguage } from "@other/interfaces";
import { TranslateService } from "@ngx-translate/core";
import { LogService } from "@services/log.service";
import { CookiesExpiredComponent } from "app/dialogs/cookies-expired/cookies-expired.component";
import { MatDialog } from "@angular/material/dialog";
@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
    @SelectSnapshot(ConfigState.GetLanguage) language: ILanguage;

    constructor(
        private injector: Injector,
        private translate: TranslateService,
        private logger: LogService,
        private dialog: MatDialog
    )
    {}

    handleError(error: any): void {
        const errorService = this.injector.get(ErrorService);
        const customErrorMessage = errorService.getCustomMessage();

        // HTTP error code 0 typically indicates a network error (CORS failure, network unavailable, etc.)
        // Skip further processing as these are usually handled at the network level
        if (error.status === 0) {
            console.log(customErrorMessage);
            return;
        }
        // let`s see the status code
        let statusCodeErrorMessage = errorService.get4xxMessage(error.status);
        this.logger.info("GlobalErrorHandler","handleError", "error.status: "+error.status)
        this.logger.info("GlobalErrorHandler","handleError", "We should offer the reload dialog");
        // open the reload dialog
        // this.dialog.open(CookiesExpiredComponent)

        // handles 4xx errors
        if (error instanceof HttpErrorResponse) {

            // check if there is a custom error message in error service, if so print error with that message and plus message based on status code
            if(customErrorMessage) {
                console.log(`${statusCodeErrorMessage}, ${customErrorMessage}`, "(3)");
                console.log(error);
            }
            // if there is no custom message, get message based on error's status code
            else {
                console.log(statusCodeErrorMessage, "(2)");
                console.log(error);
            }
        }
        // handles other errors
        else {
            console.log("This seems to be an issue from our side, We are sorry for the inconvenience. We will try to fix this as fast as possible. (1)");
            console.log(error, "(1)");

            // captureException(error);

            // opens @sentry/browser dialog, asking user for possible additional feedback
            // Sentry native captureMessage function sets the title for report item
            // the text of the dialog will be translated based on currently selected language
            // showReportDialog({eventId: captureMessage("User report"), lang: this.language, title: this.translate.instant('noData.our_issue')} );
        }
    }
}
